import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationService} from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from "primeng/dropdown";
// import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputMaskModule } from 'primeng/inputmask';

import { EfileViewComponent } from './efiling-view.component';
import { EfileDetailsComponent } from './efiling-details.component';

import { EFileApplicationDto } from 'src/app/application/efile/dto/efile-app.dto';
import { EFilePaymentDto } from 'src/app/application/efile/dto/efile-payment.dto';
import { LoginRouteGuard } from 'src/app/login-route-guard';


@NgModule({
  imports: [
    CommonModule,
    AccordionModule,
    TableModule,
    FormsModule,
    ToastModule,
    ConfirmDialogModule,
    CalendarModule,
    FileUploadModule,
    // ProgressSpinnerModule,
    InputMaskModule,
    DropdownModule,
    MultiSelectModule,
    TagModule,
    RouterModule.forChild([
      { path: 'efileview', component: EfileViewComponent, canActivate: [LoginRouteGuard] },
    ]),
  ],
    declarations: [
        EfileViewComponent,
        EfileDetailsComponent,
  ],
    providers: [
        MessageService,
        ConfirmationService,
        EFileApplicationDto,
        EFilePaymentDto,
  ]
})
export class EfilingModule {}
